import FiltersWebAPIUtils from 'utils/FiltersWebAPIUtils';
/**
 * @getFilterNames petitions FiltersWebAPIUtils for filter names
 * @returns void
 */
const getFilterNames = () => {
    FiltersWebAPIUtils.getFilterNames();
};
/**
 * @updateFilter updates filter
 * @param {*} ID - A mongo object (? or string)  with the ID of the user
 * @updates {*} upates - Any object with the updates to the filter model
 * @returns void
 */
const updateFilter = (updates) => {
    FiltersWebAPIUtils.updateFilters(updates);
};
/**
 * @createFilter adds a filter in MongoDB
 * @param {*} params - model, sharedStatus,
 * @returns void
 */
const createFilter = (params) => {
    FiltersWebAPIUtils.createFilter(params);
};
/**
 * @deleteFilter removes a filter from the db
 * @param {string} id - id of the filter
 * @returns void
 */
const deleteFilter = (id) => {
    FiltersWebAPIUtils.deleteFilter(id);
};
export default { getFilterNames, updateFilter, deleteFilter, createFilter };
